<form [formGroup]="formGroup" (ngSubmit)="createExportAltAndObj()">
  <section>
    <p i18n>Die Abgaben werden als Excel Tabelle exportiert.</p>
  </section>

  <section>
    <h4 i18n
      >Spalten der Tabelle<br />
      <span class="mat-caption">
        Der Export enthält standardmäßig bereits folgende Spalten:
        <ul>
          <li
            >Blatt Alternativen: Veranstaltung ID, Benutzer ID, Anzahl (von Alternativen), Nr. (der Alternative), Name (der
            Alternative).</li
          >
          <li>Blatt Ziele: Veranstaltung ID, Benutzer ID, Anzahl (von Zielen), Nr. (des Ziels), Name (des Ziels).</li>
        </ul>
        Hier können optional zusätzliche Spalten ausgewählt werden.
      </span>
    </h4>

    <div class="step-row">
      <button mat-stroked-button type="button" (click)="selectFullExport()" i18n><mat-icon>select_all</mat-icon> Vollständig</button>
      <button mat-stroked-button type="button" (click)="selectMinimalExport()" i18n><mat-icon>deselect</mat-icon> Minimalauswahl</button>
    </div>

    <ul class="attribute-list" formGroupName="parameters">
      <li>
        <mat-checkbox formControlName="alternativesSheet" i18n>Alternativen</mat-checkbox>
        <ul>
          <li><mat-checkbox formControlName="defaultAnalysis" i18n>Auswertung der Abgabe</mat-checkbox></li>
          <li
            ><mat-checkbox formControlName="linearNumericalAnalysis" i18n
              >Auswertung für lineare Nutzenfunktionen (numerische Skalen / Indikatorskalen)</mat-checkbox
            ></li
          >
          <li
            ><mat-checkbox formControlName="linearVerbalAnalysis" i18n
              >Auswertung für lineare Nutzenfunktionen (verbale Skalen)</mat-checkbox
            ></li
          >
          <li
            ><mat-checkbox formControlName="linearBothAnalysis" i18n
              >Auswertung für lineare Nutzenfunktionen (alle Skalen)</mat-checkbox
            ></li
          >
          <li
            ><mat-checkbox formControlName="linearMostImportantAnalyses" i18n
              >Auswertung (das n-te wichtigste Ziel ist linear)</mat-checkbox
            ></li
          >
          <li
            ><mat-checkbox formControlName="linearMostImportantAccumulatedAnalyses" i18n
              >Auswertung (die ersten n wichtigsten Ziele sind linear)</mat-checkbox
            ></li
          >
          <li
            ><mat-checkbox formControlName="linearLeastImportantAccumulatedAnalyses" i18n
              >Auswertung (das n-te unwichtigste Ziel ist linear)</mat-checkbox
            ></li
          >
          <li
            ><mat-checkbox formControlName="linearLeastImportantAccumulatedAnalyses" i18n
              >Auswertung (die ersten n unwichtigsten Ziele sind linear)</mat-checkbox
            ></li
          >
        </ul>
      </li>
      <li>
        <mat-checkbox formControlName="objectivesSheet" i18n>Ziele</mat-checkbox>
        <ul>
          <li><mat-checkbox formControlName="scaleInfo" i18n>Typ der Skala, Skalengrenzen und Einheit</mat-checkbox></li>
          <li><mat-checkbox formControlName="weightInfo" i18n>Informationen zum Zielgewicht</mat-checkbox></li>
          <li><mat-checkbox formControlName="utilityInfo" i18n>Krümmung und Präzision der Nutzenfunktion</mat-checkbox></li>
        </ul>
      </li></ul
    >
  </section>

  <section>
    <button
      mat-raised-button
      type="submit"
      color="primary"
      [disabled]="isLoading || selectedEvents.length === 0 || !areAltAndObjParametersValid()"
      [dtOverlayProgress]="isLoading"
      i18n
    >
      <mat-icon>download</mat-icon>Exportieren</button
    >
  </section>
</form>
